import { ForgotForm } from './dumb.js';
import enhance from './enhancer';

export default enhance(ForgotForm);
